export default __webpack_public_path__ + "static/up-arrow-orange-f934dd9581032b85c7978bdb1ac0be11.svg";